export default __webpack_public_path__ + "static/media/rar.010c50d1.svg";